'use client';

import React, { useEffect, useState } from 'react';
import { studioClient } from '@/sanity/lib/client';
import VideoHero from '@/shared/components/VideoHero';
import { HERO_VIDEO_QUERY } from '@/sanity/queries/heroVideo';
import { LoadingSpinner } from '@/shared';

export default function HeroSection() {
  const [heroVideo, setHeroVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHeroVideo = async () => {
      try {
        const data = await studioClient.fetch(HERO_VIDEO_QUERY);
        setHeroVideo(data);
      } catch (error) {
        console.error('Error fetching hero video:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroVideo();
  }, []);

  if (loading) {
    return (
      <section
        className="flex min-h-[675px] flex-1 items-center justify-center px-4 lg:px-8"
        aria-labelledby="hero-heading">
        <div className="container mx-auto flex flex-col items-center justify-center text-center">
          <LoadingSpinner size="lg" className="mb-4" />
        </div>
      </section>
    );
  }

  // Fallback content if no video is configured
  if (!heroVideo) {
    return (
      <section
        className="flex min-h-[675px] flex-1 items-center justify-center px-4 lg:px-8"
        aria-labelledby="hero-heading">
        <div className="container mx-auto flex flex-col items-center justify-center text-center">
          <div className="mb-6 lg:mb-8">
            <h1
              id="hero-heading"
              className="mb-4 text-3xl font-bold sm:text-4xl md:text-5xl lg:text-6xl">
              <span className="text-hero-gradient-text">
                We Offer Only the{' '}
                <span className="bg-[#3FE5A2] bg-clip-text text-transparent">Finest</span>,
              </span>
              <br />
              <span className="text-hero-gradient-text">Handpicked Homes</span>
            </h1>
          </div>

          <div className="mb-6 text-center font-medium text-white lg:mb-8">
            <p className="mb-2 text-sm sm:text-base lg:text-lg">
              Three specialized arms. One shared vision.
            </p>
            <p className="max-w-2xl text-xs leading-relaxed sm:text-sm sm:leading-relaxed md:text-base lg:text-lg">
              Under the umbrella of Eram Group, our companies operate with focus,
              <br className="hidden sm:block" />
              innovation, and strategic execution — across tech, media, and energy.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return <VideoHero data={heroVideo} />;
}
